/**
 * Adherence Service — 비즈니스 로직 계층 (현재는 thin passthrough)
 */
export class AdherenceService {
  constructor(adherenceRepository) {
    this.adherenceRepository = adherenceRepository;
  }

  async getKpiSummary(pharmacyBrn) {
    if (!pharmacyBrn) throw new Error('사업자등록번호가 필요합니다.');
    return await this.adherenceRepository.getKpiSummary(pharmacyBrn);
  }

  async getPatients(pharmacyBrn, params = {}) {
    if (!pharmacyBrn) throw new Error('사업자등록번호가 필요합니다.');
    return await this.adherenceRepository.getPatients(pharmacyBrn, params);
  }

  async getPatientDetail(userId, type) {
    if (!userId) throw new Error('사용자 ID가 필요합니다.');
    return await this.adherenceRepository.getPatientDetail(userId, type);
  }
}
